/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SelectedAPI
 * @hideconstructor
 */
define([], () => {

	class SelectedAPI {

		/**
		 * @param {object[]} tuple  Each entry in the array corresponds to the itemIds array.
		 * @example [ {u:'2005'}, {u:'Fax'} ]
		 * @return {boolean} true if the tuple items are included in the current selections.
		 */
		isSelected() {}
	}

	return SelectedAPI;
});
